import React, {useCallback} from 'react';

import {EventCreationMode} from 'src/modules/event-create/constants';
import {createEventCreationRoutePath} from 'src/modules/event-create/event-creation-route-planner';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {Role} from 'src/openapi/models/Role';
import {copy} from 'src/utils/copyToClipboard';

import Button from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import {Group} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';
import {LocalStorage} from '@pb/kit-util-client-storage';

type Props = {
    changeRequest: ChangeRequest,
};

export const CopyLinkButton = ({changeRequest}: Props) => {
    const userRoles = LocalStorage.get('user')?.roles || [];

    const onEditLinkClick = useCallback(() => {
        const eventId = changeRequest.event.id;
        const mode = eventId ? EventCreationMode.update : EventCreationMode.create;
        const changeRequestId = changeRequest.id ?? 0;

        const reviewLink = createEventCreationRoutePath({mode, eventId: eventId ?? 0, changeRequestId});

        copy(`${window.location.origin}${reviewLink}`);
    }, [changeRequest.event.id, changeRequest.id]);

    const onReviewLinkClick = useCallback(() => {
        copy(window.location.href);
    }, []);

    return (
        <>
            {(userRoles.includes(Role.ROLE_UDEDT_REVIEWER) || userRoles.includes(Role.ROLE_UDEDT_APPROVER)) && (
                <DropdownMenu
                    anchor={({anchorRef, getAnchorProps}) => (
                        <Button
                            ref={anchorRef}
                            {...getAnchorProps()}
                            endIcon={<Icon type={Icons.ANGLE_DOWN}/>}
                            variant="Type.SECONDARY">
                            Copy Link
                        </Button>
                    )}>
                    <Group direction="v" alignItems="stretch" gap="none">
                        <DropdownMenuItem
                            caption="Edit Mode Link"
                            iconAfter={Icons.COPY}
                            onClick={onEditLinkClick}
                        />
                        <DropdownMenuItem
                            caption="Review Mode Link"
                            iconAfter={Icons.COPY}
                            onClick={onReviewLinkClick}
                        />
                    </Group>
                </DropdownMenu>
            )}
        </>
    );
};
